export const getComponentName: (name: string) => string = (name: string): string => {
	return name
		.split(/\W/)
		.map((part) => `${part[0].toUpperCase()}${part.slice(1)}`)
		.join('')
		.concat('Icon');
};
